export default {
    data() {
        return {
            EXPORT_TYPE_REGULAR: 1,
            EXPORT_TYPE_FILE: 2,
            EXPORT_TYPE_ENTITY: 3,
            PROCESS_STATUS_PROCESSING: 1,
            PROCESS_STATUS_FINISHED: 2,
            PROCESS_STATUS_CANCELED: 3,
            PROCESS_STATUS_ERROR: 4,
        };
    },
};
